var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 0C27.1585 0 35 7.8415 35 17.5C35 27.1585 27.1585 35 17.5 35C7.8415 35 0 27.1585 0 17.5C0 7.8415 7.8415 0 17.5 0ZM27.9805 12.2348C27.729 11.2936 26.9878 10.5525 26.0466 10.3009C24.3405 9.84375 17.5 9.84375 17.5 9.84375C17.5 9.84375 10.6595 9.84375 8.95337 10.3009C8.0124 10.5525 7.27104 11.2936 7.01948 12.2348C6.5625 13.9407 6.5625 17.5001 6.5625 17.5001C6.5625 17.5001 6.5625 21.0594 7.01948 22.7652C7.27104 23.7064 8.0124 24.4478 8.95337 24.6993C10.6595 25.1562 17.5 25.1562 17.5 25.1562C17.5 25.1562 24.3405 25.1562 26.0466 24.6993C26.9878 24.4478 27.729 23.7064 27.9805 22.7652C28.4375 21.0594 28.4375 17.5001 28.4375 17.5001C28.4375 17.5001 28.4375 13.9407 27.9805 12.2348ZM15.3124 20.7815V14.2188L20.9956 17.5001L15.3124 20.7815Z",
    fill: "#083857"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.03b4ae80fd7784a4c83bde1064d563d0.svg";
export { ForwardRef as ReactComponent };